<app-agent-breadcrumb [inIXBRL]="true"></app-agent-breadcrumb>

<div class="page-header home no-margin-left">
  <h1 class="page-title">Document Formatting</h1>
  <p class="page-text">Agentic process to format document</p>
</div>

<!-- <app-feedback [projectId]="trialBalanceReportId"></app-feedback> -->

<!-- <app-ixbrl-instructions></app-ixbrl-instructions> -->

<div class="page-header">
  <h2 class="page-title">Document Formatting</h2>
  <p class="page-text"></p>
</div>

<div class="upload-progress-container">
  <motif-progress-indicator orientation="horizontal" variant="row" hide-icon="false" size="sm">
    @for (step of steps; track $index) {
    <motif-progress-indicator-step
      [heading]="step.title"
      [status]="step.status"
      [disabled]="false"
      size="sm"
      [clickable]="true"
    ></motif-progress-indicator-step>
    }
  </motif-progress-indicator>

  @if (currentStep === 1) {
  <!--  -->
  @if (!runDocFormattingLoading) {
  <!--  -->
  <app-custom-motif-uploader
    [file]="fileToFormat"
    [acceptDoc]="true"
    [acceptExcel]="true"
    (fileEmitter)="onFileToFormatSelected($event)"
    (fileHasError)="onFileToFormatHasError($event)"
  ></app-custom-motif-uploader>
  <!--  -->
  } @if (runDocFormattingLoading) {
  <div class="progressbar-container">
    <motif-progress-bar
      [circle]="true"
      [hideLabel]="true"
      [isIndeterminate]="true"
      [tabIndex]="0"
      aria-label="Loading."
      aria-live="polite"
    ></motif-progress-bar>
    <p progressbar-label>{{ loadingMessage }}</p>
  </div>
  }

  <motif-button
    variant="primary"
    (click)="runDocumentFormatting()"
    [disabled]="
      !fileToFormat || fileToFormatHasError || runDocFormattingLoading
    "
    aria-label="Upload Documents to Format"
    aria-live="assertive"
  >
    Upload
  </motif-button>
  <!--  -->
  }

  <!--  -->
  @if (currentStep === 2) {

  <div class="process-message-container">
    <motif-icon
      [iconFunction]="IconoirCheckCircle"
      size="20"
      class="success-check"
    ></motif-icon>
    <p class="step-duration-message">{{ docFormattingDuration }}</p>
  </div>

  <div class="file-info-container">
    <p>File: {{ fileToFormat?.name }}</p>
    <p>
      Uploaded on:
      {{ fileUploadedOn + "Z" | date : "MMM d, y h:mm a" }}
    </p>
  </div>

  @if (formattedFile) {
  <app-custom-motif-downloader
    [filename]="formattedFile.filename"
    [fileId]="formattedFile.id"
    [fileSize]="formattedFile.file_size"
  ></app-custom-motif-downloader>
  }

  <motif-button
    variant="primary-alt"
    (click)="goToPreviousStep(true)"
    [ariaLabel]="'Go back to step' + (currentStep - 1)"
    aria-live="assertive"
  >
    Go back
  </motif-button>
  }
</div>

<div class="bg-image">
  @if(currentStep === 2) { }

  <div class="buttons-container">
    <div class="left">
      <motif-button
        variant="primary-alt"
        (click)="backHome()"
        aria-label="Go to iXBRL home page"
        aria-live="polite"
      >
        iXBRL Home
      </motif-button>
      <motif-button
        variant="primary-alt"
        (click)="scrollUp()"
        aria-label="Scroll back to the top of the page"
        aria-live="polite"
      >
        Back to top
      </motif-button>
    </div>
  </div>

  <app-disclaimer></app-disclaimer>
</div>
